import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DetailHeader, SidePanelTable, Modal,SelectField } from 'cx-ui-components';
import DetailWrapper from '../../../components/DetailWrapper';
import { detailHeaderText } from '../../../utils';
import { entitiesMetaData } from '../../../redux/modules/entities/metaData';
import store from '../../../redux/store';
import Toggle from 'cx-ui-components/src/components/ConfigUi/Toggle';
import SidePanelHeaderContainer from '../../../containers/SidePanelHeader';
import { CloseIconSVG } from 'cx-ui-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrappedDetailHeader = styled(DetailHeader)`
  margin-left: 35px;
`;

const WrappedDetailHeader1 = styled.button`
border-radius: 10px;
padding: 5px 10px;
margin-bottom: 10px;

`;
const SidePanelHeader = styled.div`
  padding: 10px 14px 16px;
  border-bottom: 1px solid #dadada;
  min-height: 86px;
  display: flex;
`;

const StyledToggle = styled(Toggle)`
  margin: 9px 9px 0px 0px;
  flex-shrink: 0;
`;

const HeaderArea = styled.div`
  flex-grow: 1;
  min-width: 0;
  margin: 0 14px 5px 0;
`;

const Header = styled.h1`
  color: #474747;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 5px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SubHeader = styled.h5`
  font-family: Arial, Helvetica, sans-serif;
  color: #999999;
  font-size: 10px;
  padding-bottom: 4px;
`;


const CloseButtonWrapper = styled.div`
  float: right;
`;

export default function AlpsPanel({
  title,
  createdAt,
  updatedAt,
  toggleStatus,
  toggleDisable,
  inherited,
  children,
  userHasUpdatePermission,
  userHasDisablePermission,
  userHasViewPermission,
  alpFetching,
  versionsItems,
  historyItems,
  setSelectedSubEntityId,
  setAlpsSelectedSubEntityId,
  onCancel,
  toggleEntity,
  setTermsForm,
  itemApiPending,
  selectableVersions
}) {
  return (
    <Wrapper className="dtpanel-entity-alps">

      <SidePanelHeader>
        <StyledToggle
          id="sdpanel-toggle-status"
          data-automation="sdpanelStatusToggle"
          onChange={() => {
            var type= toggleStatus==true?"disablePolicy":"enablePolicy";
            setTermsForm(true, type)
          }}
          value={toggleStatus}
          inherited={inherited}
          disabled={toggleDisable}
        />

        <HeaderArea>
          <Header title={title}>{title}</Header>
          {createdAt && <SubHeader>{createdAt}</SubHeader>}
          {createdAt && <SubHeader>{updatedAt}</SubHeader>}
        </HeaderArea>

        <CloseButtonWrapper>
        <CloseIconSVG
          onClick = {()=> setAlpsSelectedSubEntityId('')}
          size={18}
          closeIconType="secondary"
          data-automation="dtpanelActionClose"
        />
      </CloseButtonWrapper>

      </SidePanelHeader>

      {children}

      <DetailWrapper open data-automation="AlpsPermissionsSVG">
        <WrappedDetailHeader
          userHasUpdatePermission={userHasUpdatePermission}
          text='Published Versions'
          onActionButtonClick={() => setSelectedSubEntityId('create')}
        />

        <SidePanelTable
          tableType={'sidePanel'}
          contains="alps"
          userHasUpdatePermission={userHasUpdatePermission}
          userHasViewPermission={userHasViewPermission}
          viewSubEntity={(versionId) => setSelectedSubEntityId(versionId)}
          confirmDeleteSubEntity={true}
          items={versionsItems}
          fields={entitiesMetaData.alps.membersTableFields['versions']}
          defaultSorted={[{ id: 'versionNum', desc: true }]}
          fetching={alpFetching && !versionsItems.length}
          itemApiPending={itemApiPending}
        />
      </DetailWrapper>

      <DetailWrapper open={false} data-automation="groupsDetailsSVG">
        <WrappedDetailHeader text="Change History" />
        <div className='history'>
          <WrappedDetailHeader1 type='button' onClick={() => { store.dispatch({ type: 'LOAD_HISTORY', entityName: 'alps' }) }}>load history</WrappedDetailHeader1>
        </div>

        {historyItems.length !== 0 &&
          <SidePanelTable
            tableType={'sidePanel'}
            contains="history"
            // userHasUpdatePermission={userHasUpdatePermission}
            // userHasViewPermission={userHasViewPermission}
            // viewSubEntity={(listItemId) => setSelectedSubEntityId(listItemId)}
            // confirmDeleteSubEntity={true}
            items={historyItems}
            pageSize={4}
            fields={entitiesMetaData.alps.membersTableFields['history']}
            defaultSorted={[{ id: 'updatedDate', desc: false }]}
            fetching={alpFetching && !versionsItems.length}
            itemApiPending={itemApiPending}
          />
        }
      </DetailWrapper>
    </Wrapper>
  );
}

AlpsPanel.propTypes = {
  userHasUpdatePermission: PropTypes.bool,
  userHasViewPermission: PropTypes.bool,
  children: PropTypes.any,
  alpFetching: PropTypes.bool,
  versionsItems: PropTypes.any,
  historyItems: PropTypes.any,
  itemApiPending: PropTypes.string,
  setSelectedSubEntityId: PropTypes.func,
};
